export const useSelectboxStore = defineStore('selectbox', () => {
	const selectboxDropdown = ref<HTMLElement | null>(null);

	function setSelectboxDropdown(ref: HTMLElement | null) {
		selectboxDropdown.value = ref;
	}

	return {
		selectboxDropdown,
		setSelectboxDropdown,
	};
});
